angular.module('leanlaw').controller('TimekeeperProductivitySidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.filter = {
    include: {}
  };
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);

  // $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
}]);